import { render, staticRenderFns } from "./Rides.view.vue?vue&type=template&id=94f66748"
import script from "./Rides.view.vue?vue&type=script&lang=ts"
export * from "./Rides.view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports